export const isEqualFloat = (a, b, p) => {
  return Math.abs(a - b) < Math.pow(10, -p)
}
